module.exports = "../fonts/ProximaNova-Semibold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/ProximaNova-Semibold.ttf
// module id = 586
// module chunks = 0